
jQuery.fn.gFromSearch = function() {
	return this.each( function() {
		const element = jQuery( this );
		let timer;

		const form = element.parents( 'form' );
		// form.find( 'input[type="submit"]' ).on( 'click', handleFormSubmission );
		// function handleFormSubmission( event ) {
		// 	if ( form.hasClass( 'prevent-submit' ) ) {
		// 		event.preventDefault();
		// 		// alert( 'Form submission is prevented.' );
		// 	} else {
		// 		form.submit();
		// 	}
		// }
		// if ( form.find( '.ginput_container' ).find( '.loader-container' ).length === 0 ) {
		// 	element.find( '.ginput_container' ).append( '<div class="loader-container" id="location-loader" style="display: none;"><div class="row"><div class="col-sm-6 text-center"><div class="loader4"></div></div></div></div>' );
		// }
		element.off( 'keyup paste' ).on( 'keyup paste', 'input[type="text"]', function() {
			window.clearTimeout( timer );
			setTimeout( () => {
				let value = jQuery( this ).val();
				// console.log( value );
				timer = setTimeout( () => {
					if ( value === jQuery( this ).val() && jQuery( this ).val() !== '' ) {
						if ( containsZipCode( value ) ) {
							// element.find( '#location-loader' ).show();
							element.removeClass( 'gfield_error' );
							element.find( '.validation_message' ).remove();
							value = extractZipCode( value );
							jQuery( this ).val( value );
							form.addClass( 'prevent-submit' );
							form.find( 'input[type="submit"]' ).attr( 'disabled', true );
							// console.log( value );
							jQuery.ajax( {
								url: localVars.ajax_url,
								type: 'POST',
								data: {
									action: 'location_search',
									nonce: localVars.nonce,
									value,
								},
								success( response ) {
									// console.log( response );
									// element.find( '#location-loader' ).hide();
									if ( response.title ) {
										// jQuery( '.ajax-location-field' ).find( 'select' ).val( response.title );
										element.parents( '.gform-body' ).find( '.ajax-email-field' ).find( 'input[type="email"]' ).val( response.title );
										element.parents( '.gform-body' ).find( '.ajax-webemail-field' ).find( 'input[type="email"]' ).val( response.webmaster_email );
										element.parents( '.gform-body' ).find( '.ajax-location-id' ).find( 'input[type="text"]' ).val( response.id );
										form.removeClass( 'prevent-submit' );
										form.find( 'input[type="submit"]' ).attr( 'disabled', false );
									}
								},
								error() {
									// element.find( '#location-loader' ).hide();
									form.removeClass( 'prevent-submit' );
									form.find( 'input[type="submit"]' ).attr( 'disabled', true );
									if ( element.find( '.validation_message' ).length === 0 ) {
										element.append( '<div class="gfield_description validation_message gfield_validation_message">Please re-enter a valid ZIP code.</div>' );
									}
								},
							} );
						} else {
							element.addClass( 'gfield_error' );
							if ( element.find( '.validation_message' ).length === 0 ) {
								element.append( '<div class="gfield_description validation_message gfield_validation_message">Please enter a valid ZIP code.</div>' );
							}
							element.parents( '.gform-body' ).find( '.ajax-email-field' ).find( 'input[type="email"]' ).val( '' );
							element.parents( '.gform-body' ).find( '.ajax-webemail-field' ).find( 'input[type="email"]' ).val( '' );
							element.parents( '.gform-body' ).find( '.ajax-location-id' ).find( 'input[type="text"]' ).val( '' );
							form.addClass( 'prevent-submit' );
							form.find( 'input[type="submit"]' ).attr( 'disabled', true );
						}
					} else {
						element.addClass( 'gfield_error' );
						if ( element.find( '.validation_message' ).length === 0 ) {
							element.append( '<div class="gfield_description validation_message gfield_validation_message">Please enter text in this field. It cannot be blank.</div>' );
						}
						element.parents( '.gform-body' ).find( '.ajax-email-field' ).find( 'input[type="email"]' ).val( '' );
						element.parents( '.gform-body' ).find( '.ajax-webemail-field' ).find( 'input[type="email"]' ).val( '' );
						element.parents( '.gform-body' ).find( '.ajax-location-id' ).find( 'input[type="text"]' ).val( '' );
						form.addClass( 'prevent-submit' );
						form.find( 'input[type="submit"]' ).attr( 'disabled', true );
					}
				}, 200 );
			}, 1 );
		} );
		function containsZipCode( str ) {
			// Regular expression to match a 5-digit ZIP code
			const zipCodePattern = /\b\d{5}\b/;
			return zipCodePattern.test( str );
		}
		function extractZipCode( str ) {
			// Regular expression to match a 5-digit ZIP code
			const zipCodePattern = /\b\d{5}\b/;
			const match = str.match( zipCodePattern );
			return match ? match[ 0 ] : null;
		}
	} );
};
jQuery( document ).ready( function() {
	jQuery( '.ajax-zipcode-field' ).gFromSearch();
	jQuery( '.gform_wrapper form' ).on( 'submit', function() {
		jQuery( this ).addClass( 'form-submitting' );
		jQuery( this ).addClass( 'prevent-submit' );
		jQuery( this ).find( 'input[type="submit"]' ).attr( 'value', '' );
		if ( jQuery( this ).find( '.gform_footer' ).find( '.loading-gif' ).length === 0 ) {
			jQuery( this ).find( '.gform_footer' ).append( '<span class="loading-gif">  Processing please wait...</span>' );
		}
	} );

	// jQuery( document ).on( 'gform_post_render', function( event, form_id, current_page ) {
	// 	jQuery( '.ajax-zipcode-field' ).find( 'input[type="text"]' ).val( '' );
	// 	jQuery( '.ajax-zipcode-field' ).gFromSearch();
	// 	jQuery( '.gform_wrapper form' ).on( 'submit', function() {
	// 		jQuery( this ).addClass( 'form-submitting' );
	// 		jQuery( this ).addClass( 'prevent-submit' );
	// 		jQuery( this ).find( 'input[type="submit"]' ).attr( 'value', '' );
	// 		if ( jQuery( this ).find( '.gform_footer' ).find( '.loading-gif' ).length === 0 ) {
	// 			jQuery( this ).find( '.gform_footer' ).append( '<span class="loading-gif">  Processing please wait...</span>' );
	// 		}
	// 	} );
	// } );

	jQuery( document ).on( 'gform_post_render', function( event, form_id, current_page ) {
		if ( current_page > 1 ) { // If not the first page
			setTimeout( () => {
				const formSelector = '#gform_' + form_id + ' .gform_body .gform_page:visible';
				const visibleFormPage = jQuery( formSelector );

				if ( visibleFormPage.length ) {
					jQuery( 'html, body' ).animate(
						{
							scrollTop: visibleFormPage.offset().top - 190,
						},
						500
					);
				} else {
					console.log( `No visible elements found for the selector ${ formSelector }` );
				}
			}, 300 );
		}

		// Reset ZIP code field on render
		jQuery( '.ajax-zipcode-field' ).each( function() {
			const zipcodeField = jQuery( this ).find( 'input[type="text"]' );
			if ( ! zipcodeField.val() ) {
				zipcodeField.val( '' );
			}
		} );

		jQuery( '.ajax-zipcode-field' ).gFromSearch();

		jQuery( '.gform_wrapper form' ).on( 'submit', function() {
			jQuery( this ).addClass( 'form-submitting prevent-submit' );
			jQuery( this ).find( 'input[type="submit"]' ).attr( 'value', '' );
			jQuery( this ).find( 'input[type="button"]' ).each( function() {
				if ( jQuery( this ).hasClass( 'gform_next_button' ) ) {
					jQuery( this ).attr( 'value', '' );
				}
			} );
			if ( jQuery( this ).find( '.gform_footer' ).find( '.loading-gif' ).length === 0 ) {
				jQuery( this ).find( '.gform_footer' ).append( '<span class="loading-gif">Processing please wait...</span>' );
			}
			if ( jQuery( this ).find( '.gform-page-footer' ).find( '.loading-gif' ).length === 0 ) {
				jQuery( this ).find( '.gform-page-footer' ).append( '<span class="loading-gif">Processing please wait..</span>' );
			}
		} );
	} );
} );
